import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    opened: false,
    sticky: false,
};

export const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        openFilter: (state) => {
            dispatchFilterAppEvent(true);
            document.body.classList.add('disable-large-scrollbar');
            state.opened = true;
        },
        closeFilter: (state) => {
            dispatchFilterAppEvent(false);
            document.body.classList.remove('disable-large-scrollbar');
            state.opened = false;
        },
        enableSticky: (state) => {
            state.sticky = true;
        },
        disableSticky: (state) => {
            state.sticky = false;
        },
    },
});

const dispatchFilterAppEvent = (nextActiveState) => {
    const eventName = nextActiveState ? 'app:overlayOpened' : 'app:overlayClosed';
    document.dispatchEvent(new Event(eventName));
};

export const { openFilter, closeFilter, enableSticky, disableSticky } = filterSlice.actions;

export const selectFilterStatus = (state) => state.filter;